import { AdminPermission } from '../../../services/commons/Me';
import {
    AdminPermissions,
    AdminPermissionsOnModule,
} from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';

export type UserPermissionsOnPinCodesModule = AdminPermissionsOnModule;

export class PinCodesPermissions {
    public static PIN_CODE = 'PinCodes';
    public static Admin: UserPermissionsOnPinCodesModule = {};

    public static initializePinCodesAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnPinCodes = AdminPermissions.filter(perms, PinCodesPermissions.PIN_CODE);

        PinCodesPermissions.Admin = {
            ...AdminPermissions.toAdminModulePermissions(permsOnPinCodes),
        };

        PermissionsAbilityHelper.logPermissions('PinCodes', PinCodesPermissions.Admin);
    };
}
